<template>
  <div>
    <article class="medicine-status clearfix">
      <div class="status-top">
        <h3>传统医药行业现状</h3>
        <span></span>
      </div>
      <span class="status-text">
        传统生鲜行业存在产品零散，季节性限制等情况
      </span>
      <div class="status-content clearfix">
        <div class="content" v-for="list in statusList" :key="list.id">
          <div class="content-top">
            <img :src="list.img" />
          </div>
          <div class="content-center">
            <span class="desc">{{ list.desc }}</span>
          </div>
          <div class="content-bottom">
            <span class="desc1">{{ list.desc1 }}</span>
          </div>
        </div>
      </div>
    </article>
    <article class="medicine-pain clearfix">
      <div class="pain-top">
        <h3>医药行业的痛点</h3>
        <span></span>
      </div>
      <span class="pain-text">
        线上平台的兴起以及利好政策的逐步放开，为医药电商行业提供强大助力
      </span>
      <div class="pain-content">
        <address class="content-top">
          <div class="top-left">
            <div class="text">
              电商规模逐渐扩大，网购占比不断提高，移动互联网发展迅速，医药流通迅速
            </div>
            <div class="img">01、经济环境</div>
            <div class="b-yuan">
              <div class="s-yuan"></div>
            </div>
          </div>
          <div class="top-center">
            <div class="text">
              医药电商政策逐渐开放，将进入快车道
            </div>
            <div class="img">03、政策环境</div>
            <div class="b-yuan">
              <div class="s-yuan"></div>
            </div>
          </div>
          <div class="top-right">
            <div class="text">
              主流药企持续完善生态链布局，电商与医药O2O是重点
            </div>
            <div class="img">05、企业资本动向</div>
            <div class="b-yuan">
              <div class="s-yuan"></div>
            </div>
          </div>
        </address>
        <address class="content-bottom">
          <div class="bottom-left">
            <div class="img">02、投融资环境</div>
            <div class="text">
              医药电商参与者数量逐渐增长，且融资主要集中在早期
            </div>
            <div class="b-yuan">
              <div class="s-yuan"></div>
            </div>
          </div>
          <div class="bottom-right">
            <div class="img">04、社会环境</div>
            <div class="text">
              移动互联网网民数量增长，医疗支出不断增长
            </div>
            <div class="b-yuan">
              <div class="s-yuan"></div>
            </div>
          </div>
        </address>
      </div>
    </article>
    <article class="medicine-system clearfix">
      <div class="system-top">
        <h3>医药电商的运营体系</h3>
        <span></span>
      </div>
      <span class="system-text">
        将多方资源进行有效结合，打通整条行业供应链
      </span>
      <div class="system-content">
        <img src="../../static/images/medicine/kj.png" />
      </div>
    </article>
    <article class="medicine-function clearfix">
      <div class="function-top">
        <h3>医药电商的核心功能</h3>
        <span></span>
      </div>
      <span class="function-text">
        多样化功能满足不同使用者不同要求
      </span>
      <div class="function-content">
        <h4 class="content-top">支持供应商入驻平台、供诊所、消费个人采购</h4>
        <h3 class="content-title">多供应商管理</h3>
        <address class="content">
          <img src="../../static/images/medicine/tp.png" />
          <div class="content-left left-1">
            <h3>多商户管理</h3>
            <h4>自营店铺、入驻店铺等商家经营单位的业务、财务独立核算</h4>
          </div>
          <div class="content-left left-2">
            <h3>销售人员定位查看</h3>
            <h4>
              选派距离客户位置近的售后人员及时上门，提高人员调动效率，方便管理者随时了解
            </h4>
          </div>
          <div class="content-left left-3">
            <h3>采购销售、库存管理</h3>
            <h4>管理者随时查看所有经销商、门店进销存数据</h4>
          </div>
          <div class="content-right right-1">
            <h3>在线指派任务</h3>
            <h4>将任务指派给诊所，医药代表在线进行医生拜访</h4>
          </div>
          <div class="content-right right-2">
            <h3>会员打通</h3>
            <h4>
              线上线下会员信息实时同步，多维度多渠道获取会员信息，打造品牌度与信任度
            </h4>
          </div>
          <div class="content-right right-3">
            <h3>多样营销模式</h3>
            <h4>结合大数据分析，让线上平台为每一位消费者量身定制产品、服务和优惠活动</h4>
          </div>
        </address>
      </div>
    </article>
    <!-- <address class="medicine-footer clearfix">
      <h3>让营销从此变得多姿多彩，现在咨询更多优惠！</h3>
      <a>立即咨询</a>
    </address> -->
  </div>
</template>
<script>
export default {
  name: "medicine",
  data() {
    return {
      statusList: [
        {
          id: 0,
          img: require("../../static/images/medicine/1.png"),
          desc: "行业竞争激烈门店营业下滑",
        },
        {
          id: 1,
          img: require("../../static/images/medicine/2.png"),
          desc: "医药电商解禁线下优势减弱",
        },
        {
          id: 2,
          img: require("../../static/images/medicine/3.png"),
          desc: "消费者复购率低",
        },
        {
          id: 3,
          img: require("../../static/images/medicine/4.png"),
          desc: "各种销售渠道层出不穷",
        },
        {
          id: 4,
          img: require("../../static/images/medicine/5.png"),
          desc: "无法建立有效营销分析",
        },
        {
          id: 5,
          img: require("../../static/images/medicine/6.png"),
          desc: "租房，人工等经营成本不断攀升",
        }
      ],
    }
  },
  mounted() {
  },
  methods: {
  },
  watch: {
    $route(to, from) {
      this.$router.go(0);
    }
  }
}
</script>
<style lang="stylus" scoped>
div {
  color: #333333;
}

.clearfix:before, .clearfix:after {
  content: '';
  display: table;
  clear: both;
}

.medicine-status {
  width: 1400px;
  margin: 80px auto;
  text-align: center;

  .status-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .status-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .status-text {
    display: inline-block;
    font-size: 18px;
    margin-top: 20px;
  }

  .status-content {
    justify-content: center;
    align-items: center;
    justify-items: center;
    margin-top: 34px;

    .content {
      width: 233px;
      height: 274px;
      float: left;
      margin-top: 24px;
      border: 1px solid #F5F5F5;
      box-sizing: border-box;

      .content-top {
        margin-top: 68px;
      }

      .content-center {
        font-size: 18px;
        margin-top: 36px;
        font-weight: bold;
        line-height: 28px;
        padding: 0 60px;
      }
    }

    .content:nth-child(3), .content:nth-child(6) {
      .content-center {
        padding: 0 45px;
      }
    }

    .content:hover {
      box-shadow: 0px 10px 25px 1px rgba(185, 185, 185, 0.15);
    }
  }
}

.medicine-pain {
  width: 1400px;
  margin: 80px auto;
  text-align: center;

  .pain-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .pain-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .pain-text {
    display: inline-block;
    font-size: 18px;
    margin-top: 20px;
  }

  .pain-content {
    width: 1400px;
    margin-top: 60px;

    .content-top {
      height: 186px;
      position: relative;
      border-bottom: 1px solid #F4F4F4;

      .text {
        padding: 21px 25px;
        width: 100%;
        height: 130px;
        font-size: 14px;
        line-height: 28px;
        box-sizing: border-box;
        text-align: left;
        text-align-last: center;
      }

      .img {
        position: absolute;
        top: 110px;
        width: 270px;
        height: 48px;
        font-size: 18px;
        font-weight: bold;
        line-height: 40px;
        background-image: url('../../static/images/fresh/ds.png');
      }

      .b-yuan {
        position: absolute;
        top: 176px;
        left: 125px;
        width: 20px;
        height: 20px;
        background: #F4F4F4;
        border-radius: 50%;
        box-sizing: border-box;
        padding: 5px;

        .s-yuan {
          width: 10px;
          height: 10px;
          background: #CCCCCC;
          border-radius: 50%;
        }
      }

      .top-left, .top-center, .top-right {
        width: 270px;
        height: 150px;
        float: left;
        box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
        border-radius: 7px;
      }

      .top-center {
        margin-left: 295px;

        .text {
          padding: 34px 57px;
        }

        .b-yuan {
          left: 690px;
        }
      }

      .top-right {
        margin-left: 295px;

        .text {
          padding: 34px 34px;
        }

        .b-yuan {
          left: 1260px;
        }
      }

      .top-left:hover, .top-center:hover, .top-right:hover {
        .img {
          background-image: url('../../static/images/fresh/dsh.png');
        }

        .b-yuan {
          background: #FFF9E5;

          .s-yuan {
            background: #FFC000;
          }
        }
      }
    }

    .content-bottom {
      height: 186px;
      position: relative;

      .text {
        padding: 66px 36px;
        width: 100%;
        height: 130px;
        font-size: 14px;
        line-height: 28px;
        box-sizing: border-box;
        text-align: left;
        text-align-last: center;
      }

      .img {
        position: absolute;
        top: 26px;
        width: 270px;
        height: 48px;
        font-size: 18px;
        font-weight: bold;
        line-height: 55px;
        background-image: url('../../static/images/fresh/sds.png');
      }

      .b-yuan {
        position: absolute;
        top: -10px;
        left: 408px;
        width: 20px;
        height: 20px;
        background: #F4F4F4;
        border-radius: 50%;
        box-sizing: border-box;
        padding: 5px;

        .s-yuan {
          width: 10px;
          height: 10px;
          background: #CCCCCC;
          border-radius: 50%;
        }
      }

      .bottom-left, .bottom-right {
        width: 270px;
        height: 150px;
        float: left;
        margin-left: 283px;
        margin-top: 34px;
        box-shadow: 0px 5px 17px 3px rgba(185, 185, 185, 0.15);
        border-radius: 7px;
      }

      .bottom-right {
        margin-left: 295px;

        .b-yuan {
          left: 973px;
        }
      }

      .bottom-left:hover, .bottom-right:hover {
        .img {
          background-image: url('../../static/images/fresh/sh.png');
        }

        .b-yuan {
          background: #FFF9E5;

          .s-yuan {
            background: #FFC000;
          }
        }
      }
    }
  }
}

.medicine-system {
  width: 1443px;
  margin: 0 auto;
  text-align: center;

  .system-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .system-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .system-text {
    display: inline-block;
    font-size: 18px;
    margin-top: 20px;
  }

  .system-content {
    width: 1400px;
    height: 867px;
    margin-top: 57px;
  }
}

.medicine-function {
  width: 1443px;
  margin: 80px auto;
  text-align: center;

  .function-top h3 {
    font-size: 30px;
    font-weight: 600;
    letter-spacing: 2px;
  }

  .function-top span {
    display: block;
    margin: 20px auto 0;
    content: '';
    width: 42px;
    height: 4px;
    border-bottom: 2px solid #ffc000;
  }

  .function-text {
    display: inline-block;
    font-size: 18px;
    margin-top: 20px;
  }

  .function-content {
    width: 1400px;
    height: 471px;
    margin: 0 auto;
    margin-top: 57px;

    .content-top {
      width: 1400px;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
    }

    .content-title {
      width: 1400px;
      font-size: 18px;
      font-weight: bold;
    }

    .content {
      width: 1400px;
      position: relative;

      .content-left {
        width: 310px;
        text-align: right;
        position: absolute;

        h3 {
          font-size: 18px;
          font-weight: bold;
        }

        h4 {
          font-weight: 400;
          font-size: 14px;
          line-height: 24px;
        }
      }

      .left-1 {
        top: 75px;
        left: 75px;
      }

      .left-2{
        top: 200px;
        left: 15px;
      }
      
      .left-3{
        top: 335px;
        left: -10px;
      }

       .content-right {
        width: 310px;
        text-align: left;
        position: absolute;

        h3 {
          font-size: 18px;
          font-weight: bold;
        }

        h4 {
          font-weight: 400;
          font-size: 14px;
          line-height: 24px;
        }
      }

      .right-1 {
        top: 90px;
        left: 965px;
      }

      .right-2{
        top: 200px;
        left: 1065px;
      }
      
      .right-3{
        top: 320px;
        left: 1105px;
      }
    }
  }
}

.medicine-footer {
  width: 100%;
  height: 160px;
  margin-top: 145px;
  background: url('../../static/images/fiveG/bg(1).png');
  text-align: center;
  border-sizing: border-box;
  position: relative;
  z-index: 3;

  h3 {
    padding-top: 28px;
    font-size: 24px;
    line-height: 28px;
    color: #FFFFFF;
  }

  a {
    text-decoration: none;
    display: inline-block;
    width: 170px;
    height: 50px;
    margin: 24px auto;
    font-size: 18px;
    font-weight: bold;
    color: #FFFEFC;
    line-height: 50px;
    border: 1px solid #FFFEFC;
    border-radius: 4px;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/solutionMedicine.vue